export const storageKeys = {
  user: '@ventas:usuario-logado',
  atendimento: '@ventas:atendimento',
  simulador_form: '@ventas:simulador-form',
} as const

export const DIGITOS_MAXIMOS_TELEFONE_BRASIL_PJ = 12
export const DIGITOS_MAXIMOS_TELEFONE_BRASIL_PF = 13
export const DIGITOS_MAXIMOS_TELEFONE_INTERNACIONAL = 14

export const CINCO_MINUTOS = 5 * 60 * 1000
export const TRINTA_MINUTOS = 30 * 60 * 1000
export const UMA_HORA = 60 * 60 * 1000
